// Utility function to format date from YYYY-MM-DD to DD-MM-YYYY
export function formatDateDDMMYYY(isoDate) {
    if (!isoDate) return ""; // Handle empty or undefined input
    const [year, month, day] = isoDate.split("-");
    return `${day}-${month}-${year}`;
}

export const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

export const formatTime = (date) => {
    return new Date(date).toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

export const formatDBDateDDMMYYY = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};